
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/komodo-wallet/mobile",
      function () {
        return require("private-next-pages/en/komodo-wallet/mobile/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/komodo-wallet/mobile"])
      });
    }
  